import {
  getReturoMaterialLabel,
  getReturoScanLabel
} from 'components/shop-reception/mobile/helpers'
import { SealScanForm } from 'components/shop-reception/mobile/interfaces'

export const toSealPayload = (searchCode: string, values: SealScanForm) => {
  const scanStatus = values.scanType.value === 'INVENTORY' ? 'INVENTORIED' : 'IN_DELIVERY'
  return {
    sealCode: searchCode,
    scanStatus,
    materialType: `${values.materialType.value}`,
    noticeId: 0
  }
}

export const toOfflineSealPayload = (searchCode: string, materialType: string, scanType: string) => {
  const scanStatus = scanType === 'INVENTORY' ? 'INVENTORIED' : 'IN_DELIVERY'
  return {
    sealCode: searchCode,
    scanStatus,
    materialType,
    noticeId: 0
  }
}

export const toMaterialTypeValue = (materialType: string) => ({
  value: materialType,
  label: getReturoMaterialLabel(materialType)
})

export const toScanTypeValue = (scanStatus: string) => {
  const scanType = scanStatus === 'INVENTORIED' ? 'INVENTORY' : 'DELIVERY'

  return {
    value: scanType,
    label: getReturoScanLabel(scanType)
  }
}
